import type { Company } from '@pn/core/domain/intel/company';
import { pnApiClient } from '../pnApiClient';
import { apiCompanyMapper } from './apiCompanyMapper';
import type { ApiCompany } from './types';

const requestCompanyById = async (companyId: string) => {
  const apiCompany = await pnApiClient.request<ApiCompany>({
    url: 'v1/companies/' + companyId,
  });

  return apiCompanyMapper.toDomainCompany(apiCompany);
};

const requestIntelCompanies = async () => {
  const apiIntelCompanies = await pnApiClient.request<ApiCompany[]>({
    url: 'v1/companies',
  });

  return apiIntelCompanies.map((apiCompany) => {
    return apiCompanyMapper.toDomainCompany(apiCompany);
  });
};

const requestCompaniesBySearchTerm = async (searchTerm: string) => {
  const apiIntelCompanies = await pnApiClient.request<ApiCompany[]>({
    url: 'v1/companies/find_by_name?search_term=' + searchTerm,
  });

  return apiIntelCompanies.map((apiCompany) => {
    return apiCompanyMapper.toDomainCompany(apiCompany);
  });
};

const requestAllCompanies = async () => {
  const apiIntelCompanies = await pnApiClient.request<ApiCompany[]>({
    url: 'v1/companies?show_all=true',
  });

  return apiIntelCompanies.map((apiCompany) => {
    return apiCompanyMapper.toDomainCompany(apiCompany);
  });
};

const updateCompany = async (company: Company) => {
  return pnApiClient.request<void>({
    method: 'PUT',
    url: `v1/companies/${company.id}`,
    payload: apiCompanyMapper.toTargetCompany(company),
  });
};

export const apiCompanyProvider = {
  getCompanyById: requestCompanyById,
  getCompanies: requestIntelCompanies,
  getCompaniesBySearchTerm: requestCompaniesBySearchTerm,
  getAllCompanies: requestAllCompanies,
  updateCompany,
};
